import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _36598381 = () => interopDefault(import('..\\..\\..\\client\\pages\\Announcement.vue' /* webpackChunkName: "pages/Announcement" */))
const _4eac036a = () => interopDefault(import('..\\..\\..\\client\\pages\\Care.vue' /* webpackChunkName: "pages/Care" */))
const _11194f96 = () => interopDefault(import('..\\..\\..\\client\\pages\\Consensus\\index.vue' /* webpackChunkName: "pages/Consensus/index" */))
const _659ce72a = () => interopDefault(import('..\\..\\..\\client\\pages\\DailyMarket.vue' /* webpackChunkName: "pages/DailyMarket" */))
const _2f62f844 = () => interopDefault(import('..\\..\\..\\client\\pages\\error.vue' /* webpackChunkName: "pages/error" */))
const _894dc100 = () => interopDefault(import('..\\..\\..\\client\\pages\\IR_groups.vue' /* webpackChunkName: "pages/IR_groups" */))
const _41685c62 = () => interopDefault(import('..\\..\\..\\client\\pages\\Issuccess.vue' /* webpackChunkName: "pages/Issuccess" */))
const _d363e9fa = () => interopDefault(import('..\\..\\..\\client\\pages\\Login\\index.vue' /* webpackChunkName: "pages/Login/index" */))
const _f8afa092 = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNewsFlash.vue' /* webpackChunkName: "pages/MarketNewsFlash" */))
const _152df5a0 = () => interopDefault(import('..\\..\\..\\client\\pages\\MobileStockPaper\\index.vue' /* webpackChunkName: "pages/MobileStockPaper/index" */))
const _1020aa5a = () => interopDefault(import('..\\..\\..\\client\\pages\\pdfviewer.vue' /* webpackChunkName: "pages/pdfviewer" */))
const _cf2d2128 = () => interopDefault(import('..\\..\\..\\client\\pages\\Policy.vue' /* webpackChunkName: "pages/Policy" */))
const _d9a2a112 = () => interopDefault(import('..\\..\\..\\client\\pages\\PolicyYouth.vue' /* webpackChunkName: "pages/PolicyYouth" */))
const _f29aab9c = () => interopDefault(import('..\\..\\..\\client\\pages\\Principle.vue' /* webpackChunkName: "pages/Principle" */))
const _cdf61ca4 = () => interopDefault(import('..\\..\\..\\client\\pages\\Renewal.vue' /* webpackChunkName: "pages/Renewal" */))
const _2ef5f068 = () => interopDefault(import('..\\..\\..\\client\\pages\\ServiceUse.vue' /* webpackChunkName: "pages/ServiceUse" */))
const _373c771c = () => interopDefault(import('..\\..\\..\\client\\pages\\SignUp.vue' /* webpackChunkName: "pages/SignUp" */))
const _48110223 = () => interopDefault(import('..\\..\\..\\client\\pages\\StockItem\\index.vue' /* webpackChunkName: "pages/StockItem/index" */))
const _dc8e83d8 = () => interopDefault(import('..\\..\\..\\client\\pages\\template.vue' /* webpackChunkName: "pages/template" */))
const _42226eba = () => interopDefault(import('..\\..\\..\\client\\pages\\Theme\\index.vue' /* webpackChunkName: "pages/Theme/index" */))
const _9444ed78 = () => interopDefault(import('..\\..\\..\\client\\pages\\Ticker.vue' /* webpackChunkName: "pages/Ticker" */))
const _696ca2ea = () => interopDefault(import('..\\..\\..\\client\\pages\\TodayWorld.vue' /* webpackChunkName: "pages/TodayWorld" */))
const _aa1d0ee6 = () => interopDefault(import('..\\..\\..\\client\\pages\\Verification\\index.vue' /* webpackChunkName: "pages/Verification/index" */))
const _5562eef5 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\100MBuySellRanking\\index.vue' /* webpackChunkName: "pages/Company/100MBuySellRanking/index" */))
const _014039ea = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\CreditRatioRanking\\index.vue' /* webpackChunkName: "pages/Company/CreditRatioRanking/index" */))
const _cafa308e = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\DailyShareChange\\index.vue' /* webpackChunkName: "pages/Company/DailyShareChange/index" */))
const _4873dfd6 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\DailyTreasuryStock\\index.vue' /* webpackChunkName: "pages/Company/DailyTreasuryStock/index" */))
const _7002edc2 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\Disclosure\\index.vue' /* webpackChunkName: "pages/Company/Disclosure/index" */))
const _5e09529c = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\Features\\index.vue' /* webpackChunkName: "pages/Company/Features/index" */))
const _4e20a793 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\ForeignBuySellRanking\\index.vue' /* webpackChunkName: "pages/Company/ForeignBuySellRanking/index" */))
const _049dff26 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\ForeignInstBuySellRanking\\index.vue' /* webpackChunkName: "pages/Company/ForeignInstBuySellRanking/index" */))
const _d4d4a08c = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\ForeignInstContinueRanking\\index.vue' /* webpackChunkName: "pages/Company/ForeignInstContinueRanking/index" */))
const _40c7abe0 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\JumpSlumpReason\\index.vue' /* webpackChunkName: "pages/Company/JumpSlumpReason/index" */))
const _09fd2a97 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\LoanTransaction\\index.vue' /* webpackChunkName: "pages/Company/LoanTransaction/index" */))
const _317f87bd = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\MarketAction\\index.vue' /* webpackChunkName: "pages/Company/MarketAction/index" */))
const _868209c6 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\MiddleFeatures\\index.vue' /* webpackChunkName: "pages/Company/MiddleFeatures/index" */))
const _59461c06 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\OvertimeUnusual\\index.vue' /* webpackChunkName: "pages/Company/OvertimeUnusual/index" */))
const _3a0dcb82 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\QuoteUnusual\\index.vue' /* webpackChunkName: "pages/Company/QuoteUnusual/index" */))
const _7e13f2b2 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\RecentIssue\\index.vue' /* webpackChunkName: "pages/Company/RecentIssue/index" */))
const _b89137b2 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\RiseDropRateRanking\\index.vue' /* webpackChunkName: "pages/Company/RiseDropRateRanking/index" */))
const _32e48e03 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\ShortSellingRanking\\index.vue' /* webpackChunkName: "pages/Company/ShortSellingRanking/index" */))
const _250b6d28 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\TechnicalAnalysis\\index.vue' /* webpackChunkName: "pages/Company/TechnicalAnalysis/index" */))
const _2be06c6a = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\TodayIssues\\index.vue' /* webpackChunkName: "pages/Company/TodayIssues/index" */))
const _843096a2 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\TodayPopularSearch\\index.vue' /* webpackChunkName: "pages/Company/TodayPopularSearch/index" */))
const _c18e8b48 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\VI\\index.vue' /* webpackChunkName: "pages/Company/VI/index" */))
const _87e2cb32 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\VolumeJump\\index.vue' /* webpackChunkName: "pages/Company/VolumeJump/index" */))
const _085bf932 = () => interopDefault(import('..\\..\\..\\client\\pages\\CustomerCenter\\Ad\\index.vue' /* webpackChunkName: "pages/CustomerCenter/Ad/index" */))
const _2513fddd = () => interopDefault(import('..\\..\\..\\client\\pages\\CustomerCenter\\Notice\\index.vue' /* webpackChunkName: "pages/CustomerCenter/Notice/index" */))
const _3f9788ce = () => interopDefault(import('..\\..\\..\\client\\pages\\EventNews\\All.vue' /* webpackChunkName: "pages/EventNews/All" */))
const _79e88e26 = () => interopDefault(import('..\\..\\..\\client\\pages\\EventNews\\Month.vue' /* webpackChunkName: "pages/EventNews/Month" */))
const _6c5351f7 = () => interopDefault(import('..\\..\\..\\client\\pages\\EventNews\\MonthSample.vue' /* webpackChunkName: "pages/EventNews/MonthSample" */))
const _25b0c617 = () => interopDefault(import('..\\..\\..\\client\\pages\\EventNews\\Week.vue' /* webpackChunkName: "pages/EventNews/Week" */))
const _21fb3c40 = () => interopDefault(import('..\\..\\..\\client\\pages\\EventNews\\Year.vue' /* webpackChunkName: "pages/EventNews/Year" */))
const _b4512106 = () => interopDefault(import('..\\..\\..\\client\\pages\\IR_B2B\\DataService\\index.vue' /* webpackChunkName: "pages/IR_B2B/DataService/index" */))
const _25a5000c = () => interopDefault(import('..\\..\\..\\client\\pages\\IR_B2B\\FinancialNews\\index.vue' /* webpackChunkName: "pages/IR_B2B/FinancialNews/index" */))
const _260b1872 = () => interopDefault(import('..\\..\\..\\client\\pages\\IR_B2B\\FlashService\\index.vue' /* webpackChunkName: "pages/IR_B2B/FlashService/index" */))
const _a28e322a = () => interopDefault(import('..\\..\\..\\client\\pages\\IR_B2B\\HistoryService\\index.vue' /* webpackChunkName: "pages/IR_B2B/HistoryService/index" */))
const _61f2a363 = () => interopDefault(import('..\\..\\..\\client\\pages\\IR_B2B\\IR\\index.vue' /* webpackChunkName: "pages/IR_B2B/IR/index" */))
const _60248df6 = () => interopDefault(import('..\\..\\..\\client\\pages\\IR_B2B\\IRCompanies\\index.vue' /* webpackChunkName: "pages/IR_B2B/IRCompanies/index" */))
const _01adf7e2 = () => interopDefault(import('..\\..\\..\\client\\pages\\IR_B2B\\MarketService\\index.vue' /* webpackChunkName: "pages/IR_B2B/MarketService/index" */))
const _4a2f522a = () => interopDefault(import('..\\..\\..\\client\\pages\\IR_B2B\\ScheduleService\\index.vue' /* webpackChunkName: "pages/IR_B2B/ScheduleService/index" */))
const _798aff39 = () => interopDefault(import('..\\..\\..\\client\\pages\\IR_B2B\\ServiceIntroduction\\index.vue' /* webpackChunkName: "pages/IR_B2B/ServiceIntroduction/index" */))
const _3d339560 = () => interopDefault(import('..\\..\\..\\client\\pages\\IR_B2B\\ThemeService\\index.vue' /* webpackChunkName: "pages/IR_B2B/ThemeService/index" */))
const _509e880c = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\Bond.vue' /* webpackChunkName: "pages/MarketNews/Bond" */))
const _e8e41344 = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\China.vue' /* webpackChunkName: "pages/MarketNews/China" */))
const _67a44657 = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\ClosingMarketNews\\index.vue' /* webpackChunkName: "pages/MarketNews/ClosingMarketNews/index" */))
const _2117c725 = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\CrudeOilPrice.vue' /* webpackChunkName: "pages/MarketNews/CrudeOilPrice" */))
const _1123a647 = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\DailyNewsBriefing\\index.vue' /* webpackChunkName: "pages/MarketNews/DailyNewsBriefing/index" */))
const _c325f948 = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\ExchangeRate_ProductsTrend\\index.vue' /* webpackChunkName: "pages/MarketNews/ExchangeRate_ProductsTrend/index" */))
const _218c215e = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\ForeignExchange.vue' /* webpackChunkName: "pages/MarketNews/ForeignExchange" */))
const _1d45e7d7 = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\Futures.vue' /* webpackChunkName: "pages/MarketNews/Futures" */))
const _1f18958d = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\Japan.vue' /* webpackChunkName: "pages/MarketNews/Japan" */))
const _3ddf618e = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\KOSDAQ.vue' /* webpackChunkName: "pages/MarketNews/KOSDAQ" */))
const _48675e4f = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\KOSPI.vue' /* webpackChunkName: "pages/MarketNews/KOSPI" */))
const _3c93a31d = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\MajorCompaniesFluctuationRate\\index.vue' /* webpackChunkName: "pages/MarketNews/MajorCompaniesFluctuationRate/index" */))
const _44863938 = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\MajorCountriesIndex\\index.vue' /* webpackChunkName: "pages/MarketNews/MajorCountriesIndex/index" */))
const _01359939 = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\NewYorkBond.vue' /* webpackChunkName: "pages/MarketNews/NewYorkBond" */))
const _415c82af = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\NewYorkClosing.vue' /* webpackChunkName: "pages/MarketNews/NewYorkClosing" */))
const _346b44ce = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\NewYorkExchange.vue' /* webpackChunkName: "pages/MarketNews/NewYorkExchange" */))
const _732b4e1b = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\Semicon.vue' /* webpackChunkName: "pages/MarketNews/Semicon" */))
const _bee0803a = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\SOX.vue' /* webpackChunkName: "pages/MarketNews/SOX" */))
const _1ea0df5e = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\Taiwan.vue' /* webpackChunkName: "pages/MarketNews/Taiwan" */))
const _24b82758 = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\TodaySummary\\index.vue' /* webpackChunkName: "pages/MarketNews/TodaySummary/index" */))
const _24abe745 = () => interopDefault(import('..\\..\\..\\client\\pages\\MyPage\\MemberInfo\\index.vue' /* webpackChunkName: "pages/MyPage/MemberInfo/index" */))
const _594036de = () => interopDefault(import('..\\..\\..\\client\\pages\\MyPage\\PayResponse\\index.vue' /* webpackChunkName: "pages/MyPage/PayResponse/index" */))
const _8fbd1d06 = () => interopDefault(import('..\\..\\..\\client\\pages\\MyPage\\ThemeAsk\\index.vue' /* webpackChunkName: "pages/MyPage/ThemeAsk/index" */))
const _7fb8894a = () => interopDefault(import('..\\..\\..\\client\\pages\\newsType\\htmlLoad\\index.vue' /* webpackChunkName: "pages/newsType/htmlLoad/index" */))
const _c2055386 = () => interopDefault(import('..\\..\\..\\client\\pages\\newsType\\list\\index.vue' /* webpackChunkName: "pages/newsType/list/index" */))
const _87677586 = () => interopDefault(import('..\\..\\..\\client\\pages\\Research\\DividendRateCompanyRanking.vue' /* webpackChunkName: "pages/Research/DividendRateCompanyRanking" */))
const _506626c6 = () => interopDefault(import('..\\..\\..\\client\\pages\\Research\\GrowthEstimateCompanyRanking.vue' /* webpackChunkName: "pages/Research/GrowthEstimateCompanyRanking" */))
const _8343c25e = () => interopDefault(import('..\\..\\..\\client\\pages\\Research\\GrowthEstimateThemeRanking.vue' /* webpackChunkName: "pages/Research/GrowthEstimateThemeRanking" */))
const _fbc9c6b6 = () => interopDefault(import('..\\..\\..\\client\\pages\\Research\\InfoStockInsight.vue' /* webpackChunkName: "pages/Research/InfoStockInsight" */))
const _1272926c = () => interopDefault(import('..\\..\\..\\client\\pages\\Research\\MainEarning.vue' /* webpackChunkName: "pages/Research/MainEarning" */))
const _f8634a4e = () => interopDefault(import('..\\..\\..\\client\\pages\\Research\\MarketDividendRateCompanyRanking.vue' /* webpackChunkName: "pages/Research/MarketDividendRateCompanyRanking" */))
const _403c6b06 = () => interopDefault(import('..\\..\\..\\client\\pages\\Research\\PER_PBR_EPS_ROE_CompanyRanking.vue' /* webpackChunkName: "pages/Research/PER_PBR_EPS_ROE_CompanyRanking" */))
const _da5770d0 = () => interopDefault(import('..\\..\\..\\client\\pages\\Research\\ResultDeviationCompanyRanking.vue' /* webpackChunkName: "pages/Research/ResultDeviationCompanyRanking" */))
const _687e4ee0 = () => interopDefault(import('..\\..\\..\\client\\pages\\Research\\StockFirmInvestmentOpinion.vue' /* webpackChunkName: "pages/Research/StockFirmInvestmentOpinion" */))
const _6b998976 = () => interopDefault(import('..\\..\\..\\client\\pages\\Research\\StockFirmRecommend\\index.vue' /* webpackChunkName: "pages/Research/StockFirmRecommend/index" */))
const _393c2123 = () => interopDefault(import('..\\..\\..\\client\\pages\\Research\\StockFirmReport.vue' /* webpackChunkName: "pages/Research/StockFirmReport" */))
const _362bc042 = () => interopDefault(import('..\\..\\..\\client\\pages\\Research\\StockFirmStrongBuying.vue' /* webpackChunkName: "pages/Research/StockFirmStrongBuying" */))
const _1d430cc1 = () => interopDefault(import('..\\..\\..\\client\\pages\\Theme\\DailyFeaturedTheme.vue' /* webpackChunkName: "pages/Theme/DailyFeaturedTheme" */))
const _31b27e00 = () => interopDefault(import('..\\..\\..\\client\\pages\\Theme\\ThemeBriefing\\index.vue' /* webpackChunkName: "pages/Theme/ThemeBriefing/index" */))
const _7f09628a = () => interopDefault(import('..\\..\\..\\client\\pages\\Theme\\ThemeDB\\index.vue' /* webpackChunkName: "pages/Theme/ThemeDB/index" */))
const _7a2ea695 = () => interopDefault(import('..\\..\\..\\client\\pages\\Theme\\ThemeFluctuations\\index.vue' /* webpackChunkName: "pages/Theme/ThemeFluctuations/index" */))
const _572af75a = () => interopDefault(import('..\\..\\..\\client\\pages\\Theme\\ThemeIndex\\index.vue' /* webpackChunkName: "pages/Theme/ThemeIndex/index" */))
const _2b93b4e0 = () => interopDefault(import('..\\..\\..\\client\\pages\\Analysis\\StockInfo\\Chart.vue' /* webpackChunkName: "pages/Analysis/StockInfo/Chart" */))
const _4fc56574 = () => interopDefault(import('..\\..\\..\\client\\pages\\Analysis\\StockInfo\\Outline.vue' /* webpackChunkName: "pages/Analysis/StockInfo/Outline" */))
const _f65f0cd2 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\Analysis\\Earning\\index.vue' /* webpackChunkName: "pages/Company/Analysis/Earning/index" */))
const _4cb397f5 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\Analysis\\StockHistory\\index.vue' /* webpackChunkName: "pages/Company/Analysis/StockHistory/index" */))
const _4676b626 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\Analysis\\StockHistorySearch\\index.vue' /* webpackChunkName: "pages/Company/Analysis/StockHistorySearch/index" */))
const _c3970886 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\Analysis\\StockInfo\\index.vue' /* webpackChunkName: "pages/Company/Analysis/StockInfo/index" */))
const _fc2caf80 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\Analysis\\StockNameChanged\\index.vue' /* webpackChunkName: "pages/Company/Analysis/StockNameChanged/index" */))
const _5f008494 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\Analysis\\StockThemeChart\\index.vue' /* webpackChunkName: "pages/Company/Analysis/StockThemeChart/index" */))
const _0208ab8e = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\Features\\Table.vue' /* webpackChunkName: "pages/Company/Features/Table" */))
const _046a46d9 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\OvertimeUnusual\\Table.vue' /* webpackChunkName: "pages/Company/OvertimeUnusual/Table" */))
const _63f1e2df = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\ShortSellingRanking\\Table.vue' /* webpackChunkName: "pages/Company/ShortSellingRanking/Table" */))
const _7f309b4a = () => interopDefault(import('..\\..\\..\\client\\pages\\newsType\\htmlLoad\\test.vue' /* webpackChunkName: "pages/newsType/htmlLoad/test" */))
const _179c3160 = () => interopDefault(import('..\\..\\..\\client\\pages\\Research\\StockFirmRecommend\\DailyRecommend.vue' /* webpackChunkName: "pages/Research/StockFirmRecommend/DailyRecommend" */))
const _0241bdff = () => interopDefault(import('..\\..\\..\\client\\pages\\Research\\StockFirmRecommend\\ExcludeRecommend.vue' /* webpackChunkName: "pages/Research/StockFirmRecommend/ExcludeRecommend" */))
const _508d1372 = () => interopDefault(import('..\\..\\..\\client\\pages\\Research\\StockFirmRecommend\\PortfolioEarningRateRanking.vue' /* webpackChunkName: "pages/Research/StockFirmRecommend/PortfolioEarningRateRanking" */))
const _70aed97e = () => interopDefault(import('..\\..\\..\\client\\pages\\Research\\StockFirmRecommend\\RecommendByStockFirm.vue' /* webpackChunkName: "pages/Research/StockFirmRecommend/RecommendByStockFirm" */))
const _71ec6f15 = () => interopDefault(import('..\\..\\..\\client\\pages\\Research\\StockFirmRecommend\\StockEarningRateRanking.vue' /* webpackChunkName: "pages/Research/StockFirmRecommend/StockEarningRateRanking" */))
const _0259d1b0 = () => interopDefault(import('..\\..\\..\\client\\pages\\Theme\\ThemeDB\\ThemeAll.vue' /* webpackChunkName: "pages/Theme/ThemeDB/ThemeAll" */))
const _d537050c = () => interopDefault(import('..\\..\\..\\client\\pages\\Theme\\ThemeDB\\ThemeAllAllowed\\index.vue' /* webpackChunkName: "pages/Theme/ThemeDB/ThemeAllAllowed/index" */))
const _aae11e6e = () => interopDefault(import('..\\..\\..\\client\\pages\\Theme\\ThemeDB\\ThemeAllAllowed\\ThemeDBAllowed.vue' /* webpackChunkName: "pages/Theme/ThemeDB/ThemeAllAllowed/ThemeDBAllowed" */))
const _1f24716e = () => interopDefault(import('..\\..\\..\\client\\pages\\CustomerCenter\\Ad\\Detail\\_id.vue' /* webpackChunkName: "pages/CustomerCenter/Ad/Detail/_id" */))
const _dc474098 = () => interopDefault(import('..\\..\\..\\client\\pages\\CustomerCenter\\Notice\\Detail\\_id.vue' /* webpackChunkName: "pages/CustomerCenter/Notice/Detail/_id" */))
const _335674ba = () => interopDefault(import('..\\..\\..\\client\\pages\\Theme\\ThemeDB\\ThemeAllAllowed\\_ThemeDetail.vue' /* webpackChunkName: "pages/Theme/ThemeDB/ThemeAllAllowed/_ThemeDetail" */))
const _073f4ebc = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\ForeignInstContinueRanking\\_id.vue' /* webpackChunkName: "pages/Company/ForeignInstContinueRanking/_id" */))
const _65651f10 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\JumpSlumpReason\\_id.vue' /* webpackChunkName: "pages/Company/JumpSlumpReason/_id" */))
const _31c9be76 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\MiddleFeatures\\_id.vue' /* webpackChunkName: "pages/Company/MiddleFeatures/_id" */))
const _63637762 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\RiseDropRateRanking\\_id.vue' /* webpackChunkName: "pages/Company/RiseDropRateRanking/_id" */))
const _17a3b6d4 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\TechnicalAnalysis\\_id.vue' /* webpackChunkName: "pages/Company/TechnicalAnalysis/_id" */))
const _737e0a8f = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\VolumeJump\\_id.vue' /* webpackChunkName: "pages/Company/VolumeJump/_id" */))
const _f131e2da = () => interopDefault(import('..\\..\\..\\client\\pages\\Theme\\ThemeDB\\_ThemeDetail.vue' /* webpackChunkName: "pages/Theme/ThemeDB/_ThemeDetail" */))
const _6e216b86 = () => interopDefault(import('..\\..\\..\\client\\pages\\Theme\\ThemeFluctuations\\_id.vue' /* webpackChunkName: "pages/Theme/ThemeFluctuations/_id" */))
const _f628187e = () => interopDefault(import('..\\..\\..\\client\\pages\\Theme\\ThemeIndex\\_ThemeIndexDetail.vue' /* webpackChunkName: "pages/Theme/ThemeIndex/_ThemeIndexDetail" */))
const _be52d8d0 = () => interopDefault(import('..\\..\\..\\client\\pages\\MobileStockPaper\\_id.vue' /* webpackChunkName: "pages/MobileStockPaper/_id" */))
const _013ae703 = () => interopDefault(import('..\\..\\..\\client\\pages\\newsType\\_id.vue' /* webpackChunkName: "pages/newsType/_id" */))
const _b6ef34b0 = () => interopDefault(import('..\\..\\..\\client\\pages\\index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/Announcement",
    component: _36598381,
    name: "Announcement"
  }, {
    path: "/Care",
    component: _4eac036a,
    name: "Care"
  }, {
    path: "/Consensus",
    component: _11194f96,
    name: "Consensus"
  }, {
    path: "/DailyMarket",
    component: _659ce72a,
    name: "DailyMarket"
  }, {
    path: "/error",
    component: _2f62f844,
    name: "error"
  }, {
    path: "/IR_groups",
    component: _894dc100,
    name: "IR_groups"
  }, {
    path: "/Issuccess",
    component: _41685c62,
    name: "Issuccess"
  }, {
    path: "/Login",
    component: _d363e9fa,
    name: "Login"
  }, {
    path: "/MarketNewsFlash",
    component: _f8afa092,
    name: "MarketNewsFlash"
  }, {
    path: "/MobileStockPaper",
    component: _152df5a0,
    name: "MobileStockPaper"
  }, {
    path: "/pdfviewer",
    component: _1020aa5a,
    name: "pdfviewer"
  }, {
    path: "/Policy",
    component: _cf2d2128,
    name: "Policy"
  }, {
    path: "/PolicyYouth",
    component: _d9a2a112,
    name: "PolicyYouth"
  }, {
    path: "/Principle",
    component: _f29aab9c,
    name: "Principle"
  }, {
    path: "/Renewal",
    component: _cdf61ca4,
    name: "Renewal"
  }, {
    path: "/ServiceUse",
    component: _2ef5f068,
    name: "ServiceUse"
  }, {
    path: "/SignUp",
    component: _373c771c,
    name: "SignUp"
  }, {
    path: "/StockItem",
    component: _48110223,
    name: "StockItem"
  }, {
    path: "/template",
    component: _dc8e83d8,
    name: "template"
  }, {
    path: "/Theme",
    component: _42226eba,
    name: "Theme"
  }, {
    path: "/Ticker",
    component: _9444ed78,
    name: "Ticker"
  }, {
    path: "/TodayWorld",
    component: _696ca2ea,
    name: "TodayWorld"
  }, {
    path: "/Verification",
    component: _aa1d0ee6,
    name: "Verification"
  }, {
    path: "/Company/100MBuySellRanking",
    component: _5562eef5,
    name: "Company-100MBuySellRanking"
  }, {
    path: "/Company/CreditRatioRanking",
    component: _014039ea,
    name: "Company-CreditRatioRanking"
  }, {
    path: "/Company/DailyShareChange",
    component: _cafa308e,
    name: "Company-DailyShareChange"
  }, {
    path: "/Company/DailyTreasuryStock",
    component: _4873dfd6,
    name: "Company-DailyTreasuryStock"
  }, {
    path: "/Company/Disclosure",
    component: _7002edc2,
    name: "Company-Disclosure"
  }, {
    path: "/Company/Features",
    component: _5e09529c,
    name: "Company-Features"
  }, {
    path: "/Company/ForeignBuySellRanking",
    component: _4e20a793,
    name: "Company-ForeignBuySellRanking"
  }, {
    path: "/Company/ForeignInstBuySellRanking",
    component: _049dff26,
    name: "Company-ForeignInstBuySellRanking"
  }, {
    path: "/Company/ForeignInstContinueRanking",
    component: _d4d4a08c,
    name: "Company-ForeignInstContinueRanking"
  }, {
    path: "/Company/JumpSlumpReason",
    component: _40c7abe0,
    name: "Company-JumpSlumpReason"
  }, {
    path: "/Company/LoanTransaction",
    component: _09fd2a97,
    name: "Company-LoanTransaction"
  }, {
    path: "/Company/MarketAction",
    component: _317f87bd,
    name: "Company-MarketAction"
  }, {
    path: "/Company/MiddleFeatures",
    component: _868209c6,
    name: "Company-MiddleFeatures"
  }, {
    path: "/Company/OvertimeUnusual",
    component: _59461c06,
    name: "Company-OvertimeUnusual"
  }, {
    path: "/Company/QuoteUnusual",
    component: _3a0dcb82,
    name: "Company-QuoteUnusual"
  }, {
    path: "/Company/RecentIssue",
    component: _7e13f2b2,
    name: "Company-RecentIssue"
  }, {
    path: "/Company/RiseDropRateRanking",
    component: _b89137b2,
    name: "Company-RiseDropRateRanking"
  }, {
    path: "/Company/ShortSellingRanking",
    component: _32e48e03,
    name: "Company-ShortSellingRanking"
  }, {
    path: "/Company/TechnicalAnalysis",
    component: _250b6d28,
    name: "Company-TechnicalAnalysis"
  }, {
    path: "/Company/TodayIssues",
    component: _2be06c6a,
    name: "Company-TodayIssues"
  }, {
    path: "/Company/TodayPopularSearch",
    component: _843096a2,
    name: "Company-TodayPopularSearch"
  }, {
    path: "/Company/VI",
    component: _c18e8b48,
    name: "Company-VI"
  }, {
    path: "/Company/VolumeJump",
    component: _87e2cb32,
    name: "Company-VolumeJump"
  }, {
    path: "/CustomerCenter/Ad",
    component: _085bf932,
    name: "CustomerCenter-Ad"
  }, {
    path: "/CustomerCenter/Notice",
    component: _2513fddd,
    name: "CustomerCenter-Notice"
  }, {
    path: "/EventNews/All",
    component: _3f9788ce,
    name: "EventNews-All"
  }, {
    path: "/EventNews/Month",
    component: _79e88e26,
    name: "EventNews-Month"
  }, {
    path: "/EventNews/MonthSample",
    component: _6c5351f7,
    name: "EventNews-MonthSample"
  }, {
    path: "/EventNews/Week",
    component: _25b0c617,
    name: "EventNews-Week"
  }, {
    path: "/EventNews/Year",
    component: _21fb3c40,
    name: "EventNews-Year"
  }, {
    path: "/IR_B2B/DataService",
    component: _b4512106,
    name: "IR_B2B-DataService"
  }, {
    path: "/IR_B2B/FinancialNews",
    component: _25a5000c,
    name: "IR_B2B-FinancialNews"
  }, {
    path: "/IR_B2B/FlashService",
    component: _260b1872,
    name: "IR_B2B-FlashService"
  }, {
    path: "/IR_B2B/HistoryService",
    component: _a28e322a,
    name: "IR_B2B-HistoryService"
  }, {
    path: "/IR_B2B/IR",
    component: _61f2a363,
    name: "IR_B2B-IR"
  }, {
    path: "/IR_B2B/IRCompanies",
    component: _60248df6,
    name: "IR_B2B-IRCompanies"
  }, {
    path: "/IR_B2B/MarketService",
    component: _01adf7e2,
    name: "IR_B2B-MarketService"
  }, {
    path: "/IR_B2B/ScheduleService",
    component: _4a2f522a,
    name: "IR_B2B-ScheduleService"
  }, {
    path: "/IR_B2B/ServiceIntroduction",
    component: _798aff39,
    name: "IR_B2B-ServiceIntroduction"
  }, {
    path: "/IR_B2B/ThemeService",
    component: _3d339560,
    name: "IR_B2B-ThemeService"
  }, {
    path: "/MarketNews/Bond",
    component: _509e880c,
    name: "MarketNews-Bond"
  }, {
    path: "/MarketNews/China",
    component: _e8e41344,
    name: "MarketNews-China"
  }, {
    path: "/MarketNews/ClosingMarketNews",
    component: _67a44657,
    name: "MarketNews-ClosingMarketNews"
  }, {
    path: "/MarketNews/CrudeOilPrice",
    component: _2117c725,
    name: "MarketNews-CrudeOilPrice"
  }, {
    path: "/MarketNews/DailyNewsBriefing",
    component: _1123a647,
    name: "MarketNews-DailyNewsBriefing"
  }, {
    path: "/MarketNews/ExchangeRate_ProductsTrend",
    component: _c325f948,
    name: "MarketNews-ExchangeRate_ProductsTrend"
  }, {
    path: "/MarketNews/ForeignExchange",
    component: _218c215e,
    name: "MarketNews-ForeignExchange"
  }, {
    path: "/MarketNews/Futures",
    component: _1d45e7d7,
    name: "MarketNews-Futures"
  }, {
    path: "/MarketNews/Japan",
    component: _1f18958d,
    name: "MarketNews-Japan"
  }, {
    path: "/MarketNews/KOSDAQ",
    component: _3ddf618e,
    name: "MarketNews-KOSDAQ"
  }, {
    path: "/MarketNews/KOSPI",
    component: _48675e4f,
    name: "MarketNews-KOSPI"
  }, {
    path: "/MarketNews/MajorCompaniesFluctuationRate",
    component: _3c93a31d,
    name: "MarketNews-MajorCompaniesFluctuationRate"
  }, {
    path: "/MarketNews/MajorCountriesIndex",
    component: _44863938,
    name: "MarketNews-MajorCountriesIndex"
  }, {
    path: "/MarketNews/NewYorkBond",
    component: _01359939,
    name: "MarketNews-NewYorkBond"
  }, {
    path: "/MarketNews/NewYorkClosing",
    component: _415c82af,
    name: "MarketNews-NewYorkClosing"
  }, {
    path: "/MarketNews/NewYorkExchange",
    component: _346b44ce,
    name: "MarketNews-NewYorkExchange"
  }, {
    path: "/MarketNews/Semicon",
    component: _732b4e1b,
    name: "MarketNews-Semicon"
  }, {
    path: "/MarketNews/SOX",
    component: _bee0803a,
    name: "MarketNews-SOX"
  }, {
    path: "/MarketNews/Taiwan",
    component: _1ea0df5e,
    name: "MarketNews-Taiwan"
  }, {
    path: "/MarketNews/TodaySummary",
    component: _24b82758,
    name: "MarketNews-TodaySummary"
  }, {
    path: "/MyPage/MemberInfo",
    component: _24abe745,
    name: "MyPage-MemberInfo"
  }, {
    path: "/MyPage/PayResponse",
    component: _594036de,
    name: "MyPage-PayResponse"
  }, {
    path: "/MyPage/ThemeAsk",
    component: _8fbd1d06,
    name: "MyPage-ThemeAsk"
  }, {
    path: "/newsType/htmlLoad",
    component: _7fb8894a,
    name: "newsType-htmlLoad"
  }, {
    path: "/newsType/list",
    component: _c2055386,
    name: "newsType-list"
  }, {
    path: "/Research/DividendRateCompanyRanking",
    component: _87677586,
    name: "Research-DividendRateCompanyRanking"
  }, {
    path: "/Research/GrowthEstimateCompanyRanking",
    component: _506626c6,
    name: "Research-GrowthEstimateCompanyRanking"
  }, {
    path: "/Research/GrowthEstimateThemeRanking",
    component: _8343c25e,
    name: "Research-GrowthEstimateThemeRanking"
  }, {
    path: "/Research/InfoStockInsight",
    component: _fbc9c6b6,
    name: "Research-InfoStockInsight"
  }, {
    path: "/Research/MainEarning",
    component: _1272926c,
    name: "Research-MainEarning"
  }, {
    path: "/Research/MarketDividendRateCompanyRanking",
    component: _f8634a4e,
    name: "Research-MarketDividendRateCompanyRanking"
  }, {
    path: "/Research/PER_PBR_EPS_ROE_CompanyRanking",
    component: _403c6b06,
    name: "Research-PER_PBR_EPS_ROE_CompanyRanking"
  }, {
    path: "/Research/ResultDeviationCompanyRanking",
    component: _da5770d0,
    name: "Research-ResultDeviationCompanyRanking"
  }, {
    path: "/Research/StockFirmInvestmentOpinion",
    component: _687e4ee0,
    name: "Research-StockFirmInvestmentOpinion"
  }, {
    path: "/Research/StockFirmRecommend",
    component: _6b998976,
    name: "Research-StockFirmRecommend"
  }, {
    path: "/Research/StockFirmReport",
    component: _393c2123,
    name: "Research-StockFirmReport"
  }, {
    path: "/Research/StockFirmStrongBuying",
    component: _362bc042,
    name: "Research-StockFirmStrongBuying"
  }, {
    path: "/Theme/DailyFeaturedTheme",
    component: _1d430cc1,
    name: "Theme-DailyFeaturedTheme"
  }, {
    path: "/Theme/ThemeBriefing",
    component: _31b27e00,
    name: "Theme-ThemeBriefing"
  }, {
    path: "/Theme/ThemeDB",
    component: _7f09628a,
    name: "Theme-ThemeDB"
  }, {
    path: "/Theme/ThemeFluctuations",
    component: _7a2ea695,
    name: "Theme-ThemeFluctuations"
  }, {
    path: "/Theme/ThemeIndex",
    component: _572af75a,
    name: "Theme-ThemeIndex"
  }, {
    path: "/Analysis/StockInfo/Chart",
    component: _2b93b4e0,
    name: "Analysis-StockInfo-Chart"
  }, {
    path: "/Analysis/StockInfo/Outline",
    component: _4fc56574,
    name: "Analysis-StockInfo-Outline"
  }, {
    path: "/Company/Analysis/Earning",
    component: _f65f0cd2,
    name: "Company-Analysis-Earning"
  }, {
    path: "/Company/Analysis/StockHistory",
    component: _4cb397f5,
    name: "Company-Analysis-StockHistory"
  }, {
    path: "/Company/Analysis/StockHistorySearch",
    component: _4676b626,
    name: "Company-Analysis-StockHistorySearch"
  }, {
    path: "/Company/Analysis/StockInfo",
    component: _c3970886,
    name: "Company-Analysis-StockInfo"
  }, {
    path: "/Company/Analysis/StockNameChanged",
    component: _fc2caf80,
    name: "Company-Analysis-StockNameChanged"
  }, {
    path: "/Company/Analysis/StockThemeChart",
    component: _5f008494,
    name: "Company-Analysis-StockThemeChart"
  }, {
    path: "/Company/Features/Table",
    component: _0208ab8e,
    name: "Company-Features-Table"
  }, {
    path: "/Company/OvertimeUnusual/Table",
    component: _046a46d9,
    name: "Company-OvertimeUnusual-Table"
  }, {
    path: "/Company/ShortSellingRanking/Table",
    component: _63f1e2df,
    name: "Company-ShortSellingRanking-Table"
  }, {
    path: "/newsType/htmlLoad/test",
    component: _7f309b4a,
    name: "newsType-htmlLoad-test"
  }, {
    path: "/Research/StockFirmRecommend/DailyRecommend",
    component: _179c3160,
    name: "Research-StockFirmRecommend-DailyRecommend"
  }, {
    path: "/Research/StockFirmRecommend/ExcludeRecommend",
    component: _0241bdff,
    name: "Research-StockFirmRecommend-ExcludeRecommend"
  }, {
    path: "/Research/StockFirmRecommend/PortfolioEarningRateRanking",
    component: _508d1372,
    name: "Research-StockFirmRecommend-PortfolioEarningRateRanking"
  }, {
    path: "/Research/StockFirmRecommend/RecommendByStockFirm",
    component: _70aed97e,
    name: "Research-StockFirmRecommend-RecommendByStockFirm"
  }, {
    path: "/Research/StockFirmRecommend/StockEarningRateRanking",
    component: _71ec6f15,
    name: "Research-StockFirmRecommend-StockEarningRateRanking"
  }, {
    path: "/Theme/ThemeDB/ThemeAll",
    component: _0259d1b0,
    name: "Theme-ThemeDB-ThemeAll"
  }, {
    path: "/Theme/ThemeDB/ThemeAllAllowed",
    component: _d537050c,
    name: "Theme-ThemeDB-ThemeAllAllowed"
  }, {
    path: "/Theme/ThemeDB/ThemeAllAllowed/ThemeDBAllowed",
    component: _aae11e6e,
    name: "Theme-ThemeDB-ThemeAllAllowed-ThemeDBAllowed"
  }, {
    path: "/CustomerCenter/Ad/Detail/:id?",
    component: _1f24716e,
    name: "CustomerCenter-Ad-Detail-id"
  }, {
    path: "/CustomerCenter/Notice/Detail/:id?",
    component: _dc474098,
    name: "CustomerCenter-Notice-Detail-id"
  }, {
    path: "/Theme/ThemeDB/ThemeAllAllowed/:ThemeDetail",
    component: _335674ba,
    name: "Theme-ThemeDB-ThemeAllAllowed-ThemeDetail"
  }, {
    path: "/Company/ForeignInstContinueRanking/:id",
    component: _073f4ebc,
    name: "Company-ForeignInstContinueRanking-id"
  }, {
    path: "/Company/JumpSlumpReason/:id",
    component: _65651f10,
    name: "Company-JumpSlumpReason-id"
  }, {
    path: "/Company/MiddleFeatures/:id",
    component: _31c9be76,
    name: "Company-MiddleFeatures-id"
  }, {
    path: "/Company/RiseDropRateRanking/:id",
    component: _63637762,
    name: "Company-RiseDropRateRanking-id"
  }, {
    path: "/Company/TechnicalAnalysis/:id",
    component: _17a3b6d4,
    name: "Company-TechnicalAnalysis-id"
  }, {
    path: "/Company/VolumeJump/:id",
    component: _737e0a8f,
    name: "Company-VolumeJump-id"
  }, {
    path: "/Theme/ThemeDB/:ThemeDetail",
    component: _f131e2da,
    name: "Theme-ThemeDB-ThemeDetail"
  }, {
    path: "/Theme/ThemeFluctuations/:id",
    component: _6e216b86,
    name: "Theme-ThemeFluctuations-id"
  }, {
    path: "/Theme/ThemeIndex/:ThemeIndexDetail",
    component: _f628187e,
    name: "Theme-ThemeIndex-ThemeIndexDetail"
  }, {
    path: "/MobileStockPaper/:id",
    component: _be52d8d0,
    name: "MobileStockPaper-id"
  }, {
    path: "/newsType/:id?",
    component: _013ae703,
    name: "newsType-id"
  }, {
    path: "/",
    component: _b6ef34b0,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
